<template>
  <information-default
    :nameButton="$t('views.SendForgotPassSuccess.nameButton')"
    action="login"
    :title="$t('views.SendForgotPassSuccess.title')"
  ></information-default>
</template>
<script>
import InformationDefault from "../../components/Sections/InformationDefault";
export default {
  components: {
    InformationDefault
  }
};
</script>
<style lang="scss" scoped>
</style>
